/*
 * @Description: 原生接口
 * @Author: fengd
 * @LastEditors: fengd
 * @Date: 2019-03-08 18:48:27
 * @LastEditTime: 2019-06-14 14:33:11
 */

import { noop } from '../js/utils';

/**
 * @typedef {Object} nativeInterface 原生接口
 * @property {function} readSerial 读取RFID卡号
 * @property {function} authRFID 密钥认证
 * @property {function(int pageStart, int pageEnd)} readRFIDData 读取RFID数据
 * @property {function(int pageNo, string data)} writeRFIDData 写入RFID数据
 * @property {function} connectBluetooth 连接地磁蓝牙
 * @property {function(string command)} sendCommandByBt 执行调试命令--蓝牙通信
 * @property {function} closeBluetoothConnect 关闭蓝牙连接
 * @property {function(string command)} sendTestCommandByBt 蓝牙测试接口
 * @property {function(string url, string md5)} downloadUpgradeFile 下载升级文件
 * @property {function} capture 拍照
 * @property {function} startRecord 录音
 * @property {function} voiceToText 录音转文字
 * @property {function(string oss)} uploadResource 原生开始上传照片和录音
 * @property {function(string path)} deleteResource 删除照片或者录音
 * @property {function(string path)} showFileDetail 显示文件详情，原图及播放录音
 * @property {function} finishActivity 关闭当前activity(当前页面)
 * @property {function(string color)} setStatusBarColor 设置状态栏颜色
 * @property {function(boolean isUse)} setUseNativeToolbar 是否显示原生导航栏
 * @property {function} showChart 显示原生图表
 * @property {function} getAppInfo 获取版本号
 * @property {function} upgradeApp iOS App 升级跳转到app store
 * @property {function} startBleScan 开启蓝牙扫描
 * @property {function} stopBleScan 关闭蓝牙扫描
 * @property {function} cancelReconnectBle 关闭蓝牙断连重试
 */
const nativeInterface = {
  readSerial: noop,
  authRFID: noop,
  sendRFIDCommand: noop,
  connectBluetooth: noop,
  sendCommandByBt: noop,
  closeBluetoothConnect: noop,
  sendTestCommandByBt: noop,
  downloadUpgradeFile: noop,
  capture: noop,
  startRecord: noop,
  voiceToText: noop,
  uploadResource: noop,
  deleteResource: noop,
  showFileDetail: noop,
  finishActivity: noop,
  setStatusBarColor: noop,
  setUseNativeToolbar: noop,
  showChart: noop,
  getAppInfo: noop,
  upgradeApp: noop,
  startBleScan: noop,
  stopBleScan: noop,
  cancelReconnectBle: noop,
};

const NBNativeAPI = 'NBNativeAPI';
const NativeAPI = 'NativeAPI';

Object.keys(nativeInterface).forEach((key) => {
  // eslint-disable-next-line func-names
  nativeInterface[key] = (function () {
    return function (...args) {
      if (NativeAPI in window && key in window[NativeAPI]) {
        // eslint-disable-next-line no-undef
        return window[NativeAPI][key](...args);
      }
      if (NBNativeAPI in window && key in window[NBNativeAPI]) {
        return window[NBNativeAPI][key](...args);
      }
      return new Error('原生接口不存在');
    };
  }(key));
});

export default nativeInterface;
